const NG_DROPDOWN_PANEL_SELECTOR = '.ng-dropdown-panel';

function eventTargetElement(event: Event): Element | null {
  const target = event.target;
  if (target instanceof Element) {
    return target;
  }
  if (target instanceof Node) {
    return target.parentElement;
  }
  return null;
}

/** True when the event originated inside an ng-select options panel (often appended to body). */
export function isEventInsideNgDropdownPanel(event: Event): boolean {
  return !!eventTargetElement(event)?.closest(NG_DROPDOWN_PANEL_SELECTOR);
}

/**
 * Keep wheel over an open ng-select panel from scrolling the page behind it.
 * Page scroll is what many screens treat as "close the dropdown".
 */
export function preventPageScrollOverNgDropdownPanel(event: WheelEvent): void {
  const target = eventTargetElement(event);
  if (!target) {
    return;
  }

  const panel = target.closest(NG_DROPDOWN_PANEL_SELECTOR);
  if (!panel) {
    return;
  }

  let node: HTMLElement | null =
    target instanceof HTMLElement ? target : target.parentElement;
  while (node && panel.contains(node)) {
    if (canElementScrollVertically(node, event.deltaY)) {
      return;
    }
    if (node === panel) {
      break;
    }
    node = node.parentElement;
  }

  event.preventDefault();
}

function canElementScrollVertically(el: HTMLElement, deltaY: number): boolean {
  const overflowY = getComputedStyle(el).overflowY;
  if (overflowY !== 'auto' && overflowY !== 'scroll' && overflowY !== 'overlay') {
    return false;
  }
  if (el.scrollHeight <= el.clientHeight + 1) {
    return false;
  }
  if (deltaY < 0) {
    return el.scrollTop > 0;
  }
  if (deltaY > 0) {
    return el.scrollTop + el.clientHeight < el.scrollHeight - 1;
  }
  return false;
}
